const styles = (theme) => ({
  topMessage: {
    margin: '1rem 0 1rem 10px',
    fontSize: 16,
    fontFamily: 'Roboto-Bold',

    '& .word': {
      color: theme.palette.primary.main,
    }
  }
});

export default styles;